var getStorage = function getStorage(_path) {
  var storage = null;
  if (typeof localStorage !== "undefined") {
    storage = localStorage;
  } else if (typeof window !== "undefined") {
    storage = window.localStorage;
  }
  return storage;
};
module.exports = getStorage;